module.exports = (__webpack_require__(0))(30);


//////////////////
// WEBPACK FOOTER
// delegated ./clients/web/src/collections/UserCollection.js from dll-reference girder_lib
// module id = 127
// module chunks = 0